<template>
  <div>
    <div class="form__group" v-if="status == 'email'">
      <div class="form__field">
        <label class="form__label">E-mail</label>

        <div class="form__control">
          <input class="form__input" type="text" v-model="email" />
        </div>
        <div
          class="form__message form__message--joined form__message--error"
          v-if="errors && errors.length"
        >
          <div v-for="error in errors" :key="error.key">{{ error.text }}</div>
        </div>
        <div class="form__description"></div>
      </div>

      <div class="form__field">
        <label class="form__label"></label>
        <a class="button button--bordered button--primary" @click="checkEmail">
          <span class="button__icon icon-right-open-big"></span>
        </a>
      </div>
    </div>

    <div class="form__group" v-else-if="status == 'login'">
      <div class="form__field">
        <span class="form__block">
          E-mail:
          <strong>{{ email }}</strong>
        </span>
      </div>

      <div class="form__field">
        <a class="button button--secondary" @click="reset">
          <span class="button__icon icon-cancel"></span>
        </a>
      </div>

      <div class="form__breaker"></div>

      <div class="form__field">
        <label class="form__label">Passwort</label>

        <div class="form__control">
          <input class="form__input" type="password" v-model="password" />
        </div>
        <div
          class="form__message form__message--joined form__message--error"
          v-if="errors && errors.length"
        >
          <div v-for="error in errors" :key="error.key">{{ error.text }}</div>
        </div>
        <div
          class="form__description"
          v-if="passwordreset"
        >
          <a
            class="mod mod--style--normal mod--theme--primary mod--size--14 mod--weight--400"
            target="_blank"
            :href="passwordreset"
          >
            Passwort vergessen
          </a>
        </div>
      </div>

      <div class="form__field">
        <label class="form__label"></label>
        <a class="button button--bordered button--primary" @click="checkLogin">
          <span class="button__icon icon-right-open-big"></span>
        </a>
      </div>
    </div>

    <div class="form__group" v-else-if="status == 'logged'">
      <div class="form__field">
        <span class="form__block">
          E-mail:
          <strong>{{ email }}</strong>
        </span>
      </div>

      <div class="form__field">
        <span class="form__block">
          Passwort:
          <strong>{{ password | pass }}</strong>
        </span>
      </div>

      <div class="form__field">
        <a class="button button--secondary" @click="reset">
          <span class="button__icon icon-cancel"></span>
        </a>
      </div>

      <div class="form__breaker"></div>
    </div>

    <div class="form__group" v-else-if="status == 'register'">
      <div class="form__field">
        <span class="form__block">
          E-mail:
          <strong>{{ email }}</strong>
        </span>
      </div>

      <div class="form__field">
        <a class="button button--secondary" @click="reset">
          <span class="button__icon icon-cancel"></span>
        </a>
      </div>
    </div>

    <input type="hidden" name="auth_action" :value="status" ref="action" />
    <input type="hidden" name="auth_email" :value="email" />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SupportAuth",
  props: ["passwordreset"],
  data: () => ({
    api: {
      email: "/support_email/test",
      login: "/support_login/test"
    },
    status: "email", // ['email', 'register', 'login', 'logged']
    email: "",
    password: "",
    errors: []
  }),
  methods: {
    async apiRequest(url, params) {
      try {
        const { data } = await axios.get(url, params);

        this.status =
          data.body && data.body != "error" ? data.body : this.status;
        this.errors = data.msg;

        setTimeout(_ => this.eventChange(), 0);
      } catch (err) {
        this.errors = { key: "app", text: err.text };
        this.eventChange();
      }
    },
    async checkEmail() {
      const params = { email: this.email };
      this.apiRequest(this.api.email, { params });
    },
    async checkLogin() {
      const params = { email: this.email, password: this.password };
      this.apiRequest(this.api.login, { params });
    },
    reset() {
      this.errors = [];
      this.status = "email";

      this.eventChange();
    },
    eventChange() {
      const event = new Event("change");
      this.$refs.action.dispatchEvent(event);
    }
  },
  filters: {
    pass(val) {
      return "*".repeat(val.length);
    }
  }
};
</script>
